import React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { IconButton, TableHead, TextField, Tooltip } from "@mui/material";
import { Search } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import moment from "moment";

function EnhancedTableToolbar (props) {
  const { numSelected, handleChange } = props;

  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: theme =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: "1 1 100%" }} color='inherit' variant='subtitle1' component='div'>
          {numSelected} selected
        </Typography>
      ) : (
        <Typography sx={{ flex: "1 1 100%" }} variant='h6' id='tableTitle' component='div'>
          Custom Battery List
        </Typography>
      )}
      <TextField
        placeholder='Search here...'
        InputProps={{
          endAdornment: (
            <IconButton color='inherit'>
              <Search />
            </IconButton>
          ),
        }}
        color='success'
        onChange={handleChange}
        style={{ backgroundColor: "", borderRadius: "4px" }}
      />
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const CutomBatteryList = ({ customBattery, active, handleClickOpenView }) => {
  const navigate = useNavigate();
  const redirect = data => {
    navigate("/user-details", { state: { userId: data.userId } });
  };
  const showData = customBattery.filter(e =>
    active == 0
      ? e
      : active == 1
      ? e.accountStatus == "active"
      : active == 2
      ? e.accountStatus == "pending"
      : active == 3
      ? e.accountStatus == "restricted"
      : e.accountStatus == "picked-up"
  );
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label='customized table'>
        <TableBody>
          <TableRow>
            <StyledTableCell style={{ fontWeight: "500" }}>Name</StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='right'>
              Email
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='right'>
              Date
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='right'>
              Number
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='right'>
              Quantity
            </StyledTableCell>
            <StyledTableCell style={{ fontWeight: "500" }} align='center'>
              Action
            </StyledTableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          {showData?.length == 0 && (
            <TableRow>
              <TableCell>No User found</TableCell>
            </TableRow>
          )}
          {showData.map(row => (
            <StyledTableRow key={row.userId}>
              <StyledTableCell component='th' scope='row' onClick={() => redirect(row)}>
                <span style={{ whiteSpace: "nowrap" }}>{row.name}</span>
              </StyledTableCell>
              <StyledTableCell align='right'>{row.email ? row.email : "---"}</StyledTableCell>
              <StyledTableCell align='right'>{moment(row.createdAt).format("ll")}</StyledTableCell>
              <StyledTableCell align='right'>
                {row.number ? "+" + row.number : "---"}
              </StyledTableCell>
              <StyledTableCell align='right'>
                <span
                  style={{
                    borderRadius: "3px",
                    padding: "3px 5px",
                    fontSize: "12px",
                    // color: "white",
                    fontWeight: "500",
                    // backgroundColor: row.accountVerified ? "green" : "red",
                  }}
                >
                  {row.quantity}
                </span>
              </StyledTableCell>

              <StyledTableCell align='right'>
                <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Tooltip
                    title='View'
                    style={{ cursor: "pointer" }}
                    onClick={() => handleClickOpenView(row)}
                  >
                    <RemoveRedEyeRoundedIcon />
                  </Tooltip>
                </span>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CutomBatteryList;
